var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCtaLeftArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.385,
    height: 17.14,
    viewBox: "0 0 35.385 17.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow2",
    transform: "translate(35.385 17.14) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M34.98,139.592h0L27.756,132.4a1.382,1.382,0,0,0-1.95,1.959l4.849,4.826H1.382a1.382,1.382,0,1,0,0,2.764H30.655l-4.849,4.826a1.382,1.382,0,0,0,1.95,1.959l7.222-7.188h0A1.383,1.383,0,0,0,34.98,139.592Z",
    transform: "translate(0 -132)",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaLeftArrowWhite);
export default __webpack_public_path__ + "static/media/cta-left-arrow-white.1e3c5d781a451dd3b083dfa47a59cefe.svg";
export { ForwardRef as ReactComponent };